import { useRef, useState } from "react";
import { Volume2, VolumeX, Play } from "lucide-react";

const SRC = "/media/cours/block-demo.mp4";
const POSTER = "/media/cours/block-demo-poster.jpg";

/** Portrait promo clip « Block Démo » — muted autoplay loop, tap to toggle sound. */
export const PromoVideoWidget = ({ className = "", compact = false }) => {
  const ref = useRef(null);
  const [muted, setMuted] = useState(true);
  const [playing, setPlaying] = useState(true);
  const toggleSound = () => { if (ref.current) { ref.current.muted = !muted; setMuted(!muted); if (ref.current.paused) ref.current.play().catch(() => {}); } };
  const togglePlay = () => { const v = ref.current; if (!v) return; if (v.paused) { v.play().catch(() => {}); setPlaying(true); } else { v.pause(); setPlaying(false); } };
  return (
    <div className={`relative overflow-hidden rounded-xl bg-black border border-[color:var(--border)] group ${className}`} data-testid="promo-video-widget">
      <video ref={ref} src={SRC} poster={POSTER} muted autoPlay loop playsInline preload="metadata" onClick={togglePlay} className={`w-full object-cover cursor-pointer ${compact ? "aspect-[9/12]" : "aspect-[9/16]"}`} data-testid="promo-video" />
      {!playing && <button type="button" onClick={togglePlay} aria-label="Lire" className="absolute inset-0 grid place-items-center bg-black/30"><Play className="w-10 h-10 text-white" /></button>}
      <div className="absolute inset-x-0 bottom-0 p-2 bg-gradient-to-t from-black/80 to-transparent flex items-end justify-between gap-2">
        <span className="text-[9px] uppercase tracking-[0.25em] text-white/80">Block Démo · Breakdance</span>
        <button type="button" onClick={toggleSound} data-testid="promo-video-sound" aria-label={muted ? "Activer le son" : "Couper le son"} className="w-7 h-7 rounded-full bg-white/15 backdrop-blur grid place-items-center text-white hover:bg-[color:var(--accent)] hover:text-black transition">
          {muted ? <VolumeX className="w-3.5 h-3.5" /> : <Volume2 className="w-3.5 h-3.5" />}
        </button>
      </div>
    </div>
  );
};
